{
  "close": "Stäng",
  "notifications": "Aviseringar"
}
